if (!customElements.get('lusso-infinite-collection')) {
  customElements.define('lusso-infinite-collection', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.ls-collection-load');
      this.status = this.querySelector('.ls-collection-load-status');
      this.nextUrl = this.dataset.nextUrl;
      this.loading = false;
      this.button?.addEventListener('click', () => this.load());

      const saveData = navigator.connection?.saveData;
      if (this.dataset.autoLoad === 'true' && !saveData && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.load();
        }, { rootMargin: '700px 0px' });
        this.observer.observe(this);
      }
    }

    async load() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      this.button?.setAttribute('aria-disabled', 'true');
      this.status.textContent = 'Loading more styles…';

      try {
        const response = await fetch(this.nextUrl, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingGrid = html.querySelector('#product-grid');
        const currentGrid = document.querySelector('#product-grid');
        if (!incomingGrid || !currentGrid) throw new Error('Product grid missing');

        [...incomingGrid.children].forEach((item) => currentGrid.appendChild(item));
        document.dispatchEvent(new CustomEvent('lusso:collection-appended'));
        const incomingLoader = html.querySelector('lusso-infinite-collection');
        this.nextUrl = incomingLoader?.dataset.nextUrl || '';
        this.dataset.nextUrl = this.nextUrl;
        this.status.textContent = this.nextUrl ? '' : 'All styles loaded.';
        if (!this.nextUrl) {
          this.button.hidden = true;
          this.observer?.disconnect();
        }
      } catch (error) {
        this.status.textContent = 'Could not load more styles. Please try again.';
      } finally {
        this.loading = false;
        this.button?.removeAttribute('aria-disabled');
      }
    }

    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
